import { STORE_ACTION } from "../store/store";
import { USER_STORE_ACTION } from "../store/user-store";


export const modelMixin = {
	data() {
		return {
			modelSpinners: { baseModel: false, userModel: false, searchIndexModel: false }
		};
	},




	methods: {


		getBaseModel(data) {

			if (data && data.showAlert && this.modelSpinners.baseModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}
			}

			this.modelSpinners.baseModel = true

			this.$store.dispatch({ type: STORE_ACTION.GET_BASE_MODEL, data: {} }).finally(() => {
				this.modelSpinners.baseModel = false
			})

		},



		getUserModel(data) {

			if (data && data.showAlert && this.modelSpinners.userModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}
			}

			this.modelSpinners.userModel = true

			this.$store.dispatch({ type: USER_STORE_ACTION.GET_USER_MODEL, data: {} }).finally(() => {
				this.modelSpinners.userModel = false
			})

		},

		getSearchIndexModel(data) {

			if (data && data.showAlert && this.modelSpinners.searchIndexModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}
			}

			this.modelSpinners.searchIndexModel = true

			this.$store.dispatch({ type: STORE_ACTION.GET_SEARCH_INDEX_MODEL, data: {} }).finally(() => {
				this.modelSpinners.searchIndexModel = false
			})

		},




	}
}
